'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
var fakeIndex = 'fakeIndex';
/**
 *
 * Locale | Example output
 * --- | ---
 
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/day_for_formatted_date/1/name
 */
var form = 'name';
lingojsCore.registerDynamicTags(lingojsCore.t('day_for_formatted_date', fakeIndex, 'name'));

module.exports = form;
//# sourceMappingURL=index.js.map
